import { Field, Formik } from "formik";
import { FC, useState } from "react";

import { subscribeFormValuesInitialValue, SubscriptionFormValues } from ".";
import { subscribeFormValidationSchema } from "./validations";
import { useTranslation } from "react-i18next";

import { CurrencyField } from "../elements";

import NowPaymentsApi from "@nowpaymentsio/nowpayments-api-js"
import { ICreatePayment, Error as NowPaymentsError } from '@nowpaymentsio/nowpayments-api-js/src/types';

import { ICreateInvoice } from "@nowpaymentsio/nowpayments-api-js/src/types";
import { InvoiceReturn } from "@nowpaymentsio/nowpayments-api-js/src/actions/create-invoice";
import { Box, Button, CircularProgress } from "@material-ui/core";
import { CreatePaymentReturn } from "@nowpaymentsio/nowpayments-api-js/src/actions/create-payment";

const npApi = new NowPaymentsApi({ apiKey: "XARXN19-6KG4H51-KP8JFHP-XS3YCSV" })


interface SubscribeFormProps {
  onClose: () => void;
}
export const SubscribeForm: FC<SubscribeFormProps> = ({ onClose }) => {

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  return (
    <Formik<SubscriptionFormValues>
      enableReinitialize
      initialValues={{
        ...subscribeFormValuesInitialValue(),
      }}
      validationSchema={subscribeFormValidationSchema(
      )}
      onSubmit={async (values): Promise<void> => {
        try {
          setIsSubmitting(true)
          const invoice: ICreateInvoice = {
            price_amount: 50,
            price_currency: 'eur',
            pay_currency: values.currency,
            ipn_callback_url: 'http://www.google.com',
            order_id: '1234',
            order_description: 'Subscription 2024',
            success_url: `https://${window.location.host}/subscription/success`,
            cancel_url: `https://${window.location.host}/subscription/cancel`,
          }
          console.log(invoice);
          const result: InvoiceReturn | NowPaymentsError = await npApi.createInvoice(invoice);

          if ('invoice_url' in result) {
            // window.open(result.invoice_url, "_blank", "noreferrer");
            window.location.replace(result.invoice_url)
            setIsSubmitting(false);
          }
        } catch (err) {
          console.log(err);
          setIsSubmitting(false);
        }
        // try {

        //   const invoice: ICreatePayment = {
        //     price_amount: 50,
        //     price_currency: 'eur',
        //     pay_amount: undefined,
        //     pay_currency: values.currency,
        //     ipn_callback_url: 'http://www.google.com',
        //     order_id: '1234',
        //     order_description: 'Subscription 2024',
        //     purchase_id: undefined,
        //     payout_address: undefined,
        //     payout_currency: undefined,
        //     payout_extra_id: undefined,
        //     fixed_rate: undefined,
        //   }
        //   console.log(invoice);
        //   const result: CreatePaymentReturn | NowPaymentsError = await npApi.createPayment(invoice);


        // } catch (err) {
        //   console.log(err);
        // }
      }}
    >
      {({
        handleSubmit,
        isSubmitting,
        values,
        setFieldValue,
        errors,
      }): JSX.Element => (
        <>
          {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
          {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
          {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}

          <Box sx={{ padding: "32px" }}>
            <form noValidate onSubmit={handleSubmit}>
              <Field
                name={`currency`}
                component={CurrencyField}
                // size="small"
                margin="normal"
              />

              {isSubmitting &&
                <CircularProgress />
              }
              <Box sx={{ mt: "24px" }}>
                <Button
                  disabled={isSubmitting}
                  color="primary"
                  // loading={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Subscribe
                </Button>
              </Box>
            </form>
          </Box>
        </>
      )}
    </Formik>
  );
};
